import styled from "styled-components";

export const Main = styled.div`
  padding: 20px;
  height: calc(100vh - 180px);
`;
